import { type ReactNode } from "react"
import { View } from "react-native"
import { cn } from "@/components/util/cn"

export const Container = ({
  children,
  className,
}: {
  className?: string
  children: ReactNode
}) => {
  return (
    <View
      className={cn(
        "my-1 p-5 rounded-md border-gray-300 border bg-white",
        className
      )}
    >
      {children}
    </View>
  )
}
